export class QueryString {
  public static find(param: string): string {
    const items = location.search.substr(1).split('&');
    let arr = [];
    let result = null;

    for (const item of items) {
      arr = item.split('=');

      if (arr[0] === param) {
        result = decodeURIComponent(arr[1]);
      }
    }

    return result;
  }
}
